import { Component } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { ProfileService } from "../profile/profile.service";
import { Router } from "@angular/router";
import { LoadingService } from "../shared/loading-spinner/loading.service";

@Component({
    selector: "app-create-password",
    templateUrl: "./create-password.component.html",
    styleUrl: "./create-password.component.scss",
    standalone: false,
})
export class CreatePasswordComponent {
    public passwordFormGroup: FormGroup;

    constructor(
        private _formBuilder: FormBuilder,
        private _profileService: ProfileService,
        private _router: Router,
        private _loadingService: LoadingService,
    ) {
        this.passwordFormGroup = this._formBuilder.group({
            oldPassword: ["", Validators.required],
            newPassword: ["", Validators.required],
            confirmPassword: ["", Validators.required],
        });
    }

    onFormSubmit() {
        if (this.passwordFormGroup.valid) {
            if (this.passwordFormGroup.value.newPassword === this.passwordFormGroup.value.confirmPassword) {
                this._profileService.updateProfilePassword(this.passwordFormGroup.value.oldPassword, this.passwordFormGroup.value.newPassword).subscribe((res) => {
                    this._router.navigate(["/flights"]).then(() => {
                        this._loadingService.setHttpProgressStatus(false);
                    });
                });
            } else {
                this.passwordFormGroup.get("confirmPassword").setErrors({ passwordMismatch: true });
            }
        }
    }
}
